import { render, staticRenderFns } from "./IconSvgDisplay.vue?vue&type=template&id=f3bce920&scoped=true&"
import script from "./IconSvgDisplay.vue?vue&type=script&lang=js&"
export * from "./IconSvgDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bce920",
  null
  
)

export default component.exports